<template>
    <div class="body">
        <div class="main-navi">
            <div class="navi-wrap clear">
                <h1>
                    <a href="/how_intro">
                        <img src="../../assets/img/how/logo.png" alt="How 로고">
                    </a>
                </h1>
                <ul class="pc-navi">
                    <li>
                        <span style="cursor:pointer;" @click="is_login = true">로그인</span>
                    </li>
                </ul>
                <span class="m-navi-btn pointer" style="cursor:pointer;" @click="is_login = true">
                    로그인
                </span>
            </div>
        </div>
        <!-- 메인 비쥬얼 -->
        <div class="main-visual clear">
            <div class="wrap clear">
                <div class="how-title-wrap">
                    <h2>
                        이용약관
                    </h2>
                </div>
            </div>
            <div class="main-bg"></div>
        </div>
        <div class="index-con">
            <div class="wrap">
<span style="font-weight: bold;">제 1 조(목적)</span><br>
이 약관은 ㈜캐럿솔루션즈(이하 HOW라 칭함)에서 제공하는<br>
영어교육 서비스를 이용함에 있어 이용자의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.<br><br>
<span style="font-weight: bold;">제 2 조(정의)</span><br>
① 이용자 : 이용자란 웹사이트에 접속하여 이 약관에 따라 HOW가 제공하는 서비스를 받는 회원 및 비회원을 말합니다.<br>
② 회원 : 회원이란 HOW에 개인정보를 제공하여 회원등록을 한 자로서, HOW의 서비스를 지속적으로 제공받으며, HOW가 제공하는 서비스를 계속적으로 이용할 수 있는 자를 말합니다.<br>
③ 비회원 : 비회원이라 함은 회원에 가입하지 않고 HOW가 제공하는 서비스를 이용하는 자를 말합니다.<br>
④ 수강신청 : 수강신청이란 회원이 HOW에서 제공하는 온라인 유/무료 서비스를 이용하기 위하여 HOW가 정한 별도의 기준 및 절차에 따라 이용을 신청하는 것을 의미합니다.<br>
⑤ 수강료 : HOW가 제공하는 유료강의를 이용하기 위한 대가로 HOW가 정한 별도의 요금체계에 의해 특정기간 단위로 부과 되는 금액을 의미합니다.<br>
⑥ 수강승인 : 회원이 HOW에게 수강신청을 요구하고 HOW가 유/무료강의 이용을 승인하는 것을 의미합니다.<br><br>
<span style="font-weight: bold;">제 3 조(약관의 명시와 개정)</span><br>
① HOW는 이 약관의 내용과 상호, 영업소, 소재지, 대표자의 성명, 사업자등록번호, 연락처(전화, 팩스, 전자우편 주소 등) 등을 이용자가 알 수 있도록 HOW 웹사이트에 게시합니다.<br>
② HOW는 약관의 구제등에 관한 법률, 전자거래기본법, 전자 서명 법, 정보통신망이용촉진 등에 관한 법률, 방문판매 등에 관한 법률, 소비자보호법 등 관련법을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.<br>
③ HOW가 이 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 HOW 초기화면에 그 적용일자 7일 이전부터 적용일자 전일까지 공지합니다.<br>
④ HOW가 이 약관을 개정할 경우에는 그 개정약관은 그 적용일자 이후에 체결되는 계약에만 적용되고 그 이전에 이미 체결된 계약에 대해서는 개정전의 약관조항이 그대로 적용됩니다.<br>
다만 이미 계약을 체결한 이용자가 개정 약관 조항의 적용을 받기를 원하는 뜻을 제3항에 의한 개정약관의 공지기간 내에 HOW에 송신하여 HOW의 동의를 받은 경우에는 개정약관 조항이 적용됩니다.<br>
⑤ "회원"은 변경된 약관이 공지된 후 15일 이내에 변경된 약관에 대한 거부의사를 표명할 수 있으며 "회원"이 거부의사를 표명할 경우 HOW는 "회원"과의 계약을 해지할 수 있습니다.<br>
만약 "회원"이 변경된 약관이 공지된 후 15일 이내에 거부의사를 표시하지 않는 경우에는 변경된 약관에 동의하는 것으로 간주합니다.<br>
⑥ 이 약관에서 정하지 아니한 사항과 이 약관의 해석에 관하여는 정부가 제정한 전자거래소비자보호지침 및 관계법령 또는 상관례에 따릅니다.<br><br>
<span style="font-weight: bold;">제 4 조(서비스의 제공 및 변경)</span><br>
① HOW는 다음과 같은 업무를 수행합니다.<br>
1. 학습정보 제공과 유/무료 서비스 정보제공 및 구매계약의 체결<br>
2. 구매계약이 체결된 온라인 유/무료 서비스 제공<br>
3. 기타 HOW가 정하는 업무<br>
② HOW는 HOW가 제공하는 서비스 및 기술적 사양 변경 등의 경우에는<br>
장차 체결되는 계약에 의해 제공할 서비스 내용을 변경할 수 있습니다.<br>
이 경우에는 변경된 서비스의 내용 및 제공일자를 명시하여<br>
현재의 재화·및 용역의 내용을 게시한 곳에 그 제공일자 이전 7일부터 공지합니다.<br>
③ HOW가 제공하기로 이용자와 계약을 체결한 서비스의 내용을<br>
HOW의 내부적인 사유로 변경할 경우에는 HOW는 이로 인하여 이용자가 입은 손해를 배상합니다.<br>
단, HOW의 고의 또는 과실이 없는 경우에는 그러하지 아니합니다.<br><br>
<span style="font-weight: bold;">제 5 조(서비스의 중단)</span><br>
① HOW는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다.<br>
② 제 1항에 의한 서비스 중단의 경우에는 HOW는 제 8조에 정한 방법으로 이용자에게 통지합니다.<br>
③ HOW는 제 1항의 사유로 서비스의 제공이 일시적으로 중단됨으로 인하여 이용자 또는 제 3자가 입은 손해에 대하여 배상합니다.<br>
단, HOW의 고의 또는 과실이 없는 경우에는 그러하지 아니합니다.<br><br>
<span style="font-weight: bold;">제 6 조(회원가입)</span><br>
① 이용자는 이 약관에 동의한다는 의사표시를 한 후 HOW가 정한 가입 양식에 따라 회원정보를 기입함으로써 회원가입을 신청합니다.<br>
② HOW는 제1항과 같이 회원으로 가입할 것을 신청한 이용자 중 다음 각 호에 해당하지 않는 한 온라인 및 모바일회원으로 등록합니다.<br>
1. 가입신청자가 이 약관 제7조 제3항에 의하여 이전에 회원자격을 상실한 적이 있는 경우, 다만 제7조 제3항에 의한 회원자격 상실 후 3년이 경과한 자로서 HOW의 회원 재가입 승낙을 얻은 경우에는 예외로 한다.<br>
2. 등록내용에 허위, 기재누락, 오기가 있는 경우<br>
3. 기타 회원으로 등록하는 것이 HOW의 기술상 현저한 지장이 있다고 판단되는 경우<br>
③ 회원가입계약의 성립시기는 HOW의 승낙이 회원에게 도달한 시점으로 합니다.<br>
④ 회원은 제 15조 제 1항에 의한 등록사항에 변경이 있는 경우, 즉시 전자우편, 기타 방법으로 HOW에 그 변경사항을 알려야 합니다.<br><br>
<span style="font-weight: bold;">제 7 조(회원탈퇴 및 자격 상실 등)</span><br>
① 회원은 HOW에 언제든지 탈퇴를 요청할 수 있으며 HOW는 즉시 회원탈퇴를 처리합니다.<br>
② 회원이 다음 각 호의 사유에 해당하는 경우, HOW는 회원자격을 제한 및 정지시킬 수 있습니다.<br>
1. 가입 신청 시에 허위 내용을 등록한 경우<br>
2. HOW를 이용하여 구입한 재화, 용역 등의 대금, 기타 HOW 이용에 관련하여 회원이 부담하는 채무를 기일에 지급하지 않는 경우<br>
3. 다른 사람의 HOW 이용을 방해하거나 그 정보를 도용하는 등 전자거래질서를 위협하는 경우<br>
4. HOW를 이용하여 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우<br>
③ HOW가 회원자격을 제한, 정지 시킨 후, 동일한 행위가 2회 이상 반복되거나 30일 이내에 그 사유가 시정되지 아니하는 경우 HOW는 회원자격을 상실 시킬 수 있습니다.<br>
④ HOW가 회원자격을 상실 시키는 경우에는 회원등록을 말소합니다. 이 경우 회원에게 이를 통지하고, 회원등록 말소 전에 소명할 기회를 부여합니다.<br><br>
<span style="font-weight: bold;">제 8 조(회원에 대한 통지)</span><br>
① HOW는 회원에 대한 통지를 하는 경우, 회원이 HOW에 제출한 전자우편 주소 및 SMS로 할 수 있습니다.<br>
② HOW는 불특정다수 회원에 대한 통지의 경우 1주일이상 HOW 게시판에 게시 함으로서 개별 통지에 갈음할 수 있습니다.<br><br>
<span style="font-weight: bold;">제 9 조(수강신청)</span><br>
① 회원은 HOW가 지정한 수강신청서를 작성, 제출함으로써 온라인 유/무료 강의를 수강신청 할 수 있습니다.<br>
② HOW는 수강신청에 대하여 다음 각 호에 해당하지 않는 한 수강신청을 승낙합니다.<br>
1. 신청 내용에 허위, 기재누락, 오기가 있는 경우<br>
2. 수강신청에 승낙하는 것이 HOW 기술상 현저히 지장이 있다고 판단하는 경우<br><br>
<span style="font-weight: bold;">제 10 조(수강료의 납부)</span><br>
① 회원은 HOW가 제공하는 온라인 유료강의를 수강하기 위해서는 지정된 수강료를 지불해야만 합니다.<br>
② 수강료는 HOW가 지정한 요금체계에 의하며 HOW에 공지한 가격을 기준으로 합니다.<br>
③ 수강료 지급방법은 다음 각 호의 하나로 할 수 있습니다.<br>
1. 신용카드 결제<br>
2. 휴대폰 결제<br>
3. 온라인 계좌이체<br>
4. 무통장 입금<br>
④수강신청 후 7일 이내 수강료를 지불하지 않을 시 수강신청이 자동 취소됩니다.<br><br>
<span style="font-weight: bold;">제 11 조(수신확인통지, 수강신청 변경 및 취소)</span><br>
① HOW는 회원의 수강신청이 있는 경우 회원에게 수신확인 통지를 합니다.<br>
② 수신확인통지를 받은 회원은 의사표시의 불일치 등이 있는 경우에는 수신확인 통지를 받은 후 즉시 수강신청 변경 및 취소를 요청할 수 있습니다.<br>
③ HOW는 수강승인 전 회원의 수강신청 변경 및 취소 요청이 있는 때에는 지체 없이 그 요청에 따라 처리합니다.<br><br>
<span style="font-weight: bold;">제 12 조(수강승인)</span><br>
① HOW는 회원으로부터 지정된 수강료 입금이 확인되는 즉시, 수강료를 지불한 유료강의에 대한 수강을 승인합니다.<br>
② HOW는 회원이 신용카드 및 온라인 계좌이체, 유/무선 전화결제로 수강료를 지급할 경우, 결제완료와 동시에 수강료를 지불한 유료강의에 대한 수강을 즉시 승인합니다.<br>
③ HOW는 회원이 무통장 입금으로 수강료를 지급할 경우, 수강료 입금확인과 동시에 수강료를 지불한 유료강의에 대한 수강을 즉시 승인합니다.<br>
④ HOW는 회원의 수강신청에 따른 승인이 이루어졌을 경우, 이를 회원에게 통지합니다.<br>
⑤ 수강이 승인된 정해진 관리system 의해서 학습을 시작할 수 있으며, 지정된 학습기간이 종료된 후에는 별도의 재학습 기간을 제공해 드리지 않고 있습니다.<br><br>
<span style="font-weight: bold;">제 13 조(수강취소 및 환불)</span><br>
환불의 규정은 아래와 같으며 이는 평생교육 사업법에 의거하여 규정되었습니다.<br>
① 서비스 이용료 징수기간이 1개월 이내인 경우<br>
1) 수업시작 전 - 기납입한 이용료 전액<br>
2) 총 수업시간의 1/3이 경과하기 전 - 기납입한 이용료의 2/3에 해당되는 금액<br>
3) 총 수업시간의 1/2이 경과하기 전 - 기납입한 이용료의 1/2에 해당되는 금액<br>
4) 총 수업시간의 1/2이 경과한 후 - 반환하지 아니함<br>
② 서비스 이용료 징수기간이 1개월을 초과하는 경우<br>
1) 수업시작 전 - 기납입한 이용료 전액<br>
2) 수업시작 후 - 환불사유가 발생한 그 달의 환불대상 이용료<br>
(이용료 징수기간이 1개월 이내인 경우에 준하여 산출된 이용료)와 나머지 달의 이용료 전액을 합산한 금액 )<br>
단, 장기수강에 따른 할인율이 적용된 경우, 환불사유 적용시점에서<br>
수업이 완료된 개월에 대해 할인액을 재적용하여 환불 전 적용된 할인액과의 차액을 환불금액에서 차감합니다.<br>
단, 재적용되는 할인액은 신청한 상품의 수강신청페이지상에서 완료된 개월에 준한 할인율을 기준으로 합니다.<br>
환불금액은 환불 신청 후 일주일 내에 고객님이 요청한 통장으로 입금이 되며,<br>
카드로 결제한 고객분은 교재금액 및 종료된 수업횟수의 수강료를<br>
HOW 통장계좌(우리: 1005-603-312534, 주식회사 캐럿솔루션즈)로 입금하시면 승인취소가 가능합니다.<br><br>
<span style="font-weight: bold;">제 14 조(개인정보보호)</span><br>
① HOW는 이용자의 정보수집 시 구매계약 이행에 필요한 최소한의 정보를 수집합니다.<br>
다음 사항을 필수사항으로 하며 그 외 사항 은 선택사항으로 합니다.<br>
1. 성명
2. 희망 ID<br>
3. 비밀번호<br>
4. e-mail 주소<br>
② HOW는 이용자의 개인식별이 가능한 개인정보를 수집하는 때에는 반드시 당해 이용자의 동의를 받습니다.<br>
③ 제공된 개인정보는 당해 이용자의 동의 없이 목적 외의 이용이나 제3자에게 제공할 수 없으며, 이에 대한 모든 책임은 HOW가 집니다.<br>
다만, 다음의 경우에는 예외로 합니다.<br>
1. 서비스 협력 업체와 학사관리에 필요한 최소한의 이용자 정보(성명, e-mail 주소)를 알려주는 경우<br>
2. 통계작성, 학술연구 또는 시장조사를 위하여 필요한 경우로서 특정 개인을 식별할 수 없는 형태로 제공하는 경우<br>
④ HOW는 제2항과 제3항에 의해 이용자의 동의를 받아야 하는 경우에는 개인정보관리 책임자의 신원(소속, 성명 및 전화번호 기타 연락처), 정보의 수집목적 및 이용목적, 제3자에 대한 정보제공 관련사항(제공받는 자, 제공 목적 및 제공할 정보의 내용) 등 정보통신망이용촉진법에 관한 법률 제16조 제3항이 규정한 사항을 미리 명시하거나 고지해야 하며 이용자는 언제든지 이 동의를 철회할 수 있습니다.<br>
⑤ 이용자는 언제든지 HOW가 가지고 있는 자신의 개인정보에 대해 열람 및 오류정정을 요구할 수 있으며 HOW는 이에 대해 지체 없이 필요한 조치를 취할 의무를 집니다.<br>
이용자가 오류의 정정을 요구한 경우에는 HOW는 그 오류를 정정할 때까지 당해 개인정보를 이용하지 않습니다.<br>
⑥ HOW는 개인정보 보호를 위하여 관리자를 한정하여 그 수를 최소화하며 신용카드, 은행계좌 등을 포함한 이용자의 개인정보의 분실, 도난, 유출, 변조 등으로 인한 이용자의 손해에 대하여 모든 책임을 집니다.<br>
⑦ HOW 또는 그로부터 개인정보를 제공받은 제3자는 개인정보의 수집목적 또는 제공받은 목적을 달성한 때에는 당해 개인정보를 지체 없이 파기합니다.<br><br>
<span style="font-weight: bold;">제 15 조(HOW의 의무)</span><br>
① HOW는 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며 이 약관이 정하는 바에 따라 지속적이고, 안정적으로 재화·용역을 제공하는데 최선을 다하여야 합니다.<br>
② HOW는 이용자가 안전하게 인터넷 서비스를 이용할 수 있도록 이용자의 개인정보(신용정보 포함)보호를 위한 보안 시스템을 갖추어야 합니다.<br>
③ HOW는 상품이나 용역에 대하여 「표시·광고의 공정화에 관한 법률」 제3조 소정의 부당한 표시·광고행위를 함으로써 이용자 가 손해를 입은 때에는 이를 배상할 책임을 집니다.<br>
④ HOW는 이용자가 원하지 않는 영리목적의 광고성 전자우편을 발송하지 않습니다.<br><br>
<span style="font-weight: bold;">제 16 조( 회원의 ID 및 비밀번호에 대한 의무)</span><br>
① 제15조의 경우를 제외한 ID와 비밀번호에 관한 관리책임은 회원에게 있습니다.<br>
② 회원은 자신의 ID 및 비밀번호를 제3자에게 이용하게 해서는 안됩니다.<br>
③ 회원이 자신의 ID 및 비밀번호를 도난 당하거나 제3자가 사용하고 있음을 인지한 경우에는 바로 HOW에 통보하고 HOW의 안내가 있는 경우에는 그에 따라야 합니다.<br><br>
<span style="font-weight: bold;">제 17 조(이용자의 의무)</span><br>
이용자는 다음 행위를 하여서는 안됩니다.<br>
1. 신청 또는 변경 시 허위내용의 등록<br>
2. HOW에 게시된 정보의 변경<br>
3. HOW가 정한 정보 이외의 정보(컴퓨터 프로그램 등)의 송신 또는 게시<br>
4. HOW 기타 제3자의 저작권 등 지적재산권에 대한 침해<br>
5. HOW 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위<br>
6. 외설 또는 폭력적인 메시지·화상·음성 기타 공서양속에 반하는 정보를 HOW에 공개 또는 게시하는 행위<br><br>
<span style="font-weight: bold;">제 18 조(HOW와 연결사이트 간의 관계)</span><br>
① HOW와 연결 사이트란 하이퍼 링크(예 : 하이퍼 링크의 대상에는 문자, 그림 및 동화상 등이 포함됨)방식 등으로 연결된 경우를 말합니다.<br>
② HOW는 연결 사이트가 독자적으로 제공하는 서비스에 의하여 이용자와 행하는 거래에 대해서 보증책임을 지지 않습니다.<br><br>
<span style="font-weight: bold;">제 19 조(저작권의 귀속 및 이용제한)</span><br>
① HOW가 작성한 저작물에 대한 저작권 기타 지적재산권은 HOW에 귀속됩니다.<br>
② 이용자는 HOW를 이용함으로써 얻은 정보를 HOW의 사전 승낙 없이 복제, 송신, 출판, 배포, 방송 기타 방법에 의하여 영리 목적으로 이용하거나 제3자에게 이용하게 하여서는 안됩니다.<br><br>
<span style="font-weight: bold;">제 20 조(분쟁해결)</span><br>
① HOW는 이용자가 제기하는 정당한 의견이나 불만을 반영하고 그 피해를 보상처리하기 위하여 피해보상처리기구를 설치· 운영합니다.<br>
② HOW는 이용자로부터 제출되는 불만사항 및 의견은 우선적으로 그 사항을 처리합니다.<br>
다만, 신속한 처리가 곤란한 경우에는 이용자에게 그 사유와 처리일정을 즉시 통보해 드립니다.<br>
③ HOW와 이용자 간에 발생한 분쟁은 전자거래기본법 제28조 및 동 시행령 제15조에 의하여 설치된 전자거래분쟁조정위원회의 조정에 따를 수 있습니다.<br><br>
<span style="font-weight: bold;">제 21 조(재판권 및 준거 법)</span><br>
① HOW와 이용자 간에 발생한 전자거래 분쟁에 관한 소송은 민사소송법상의 관할법원에 제기합니다.<br>
② HOW와 이용자 간에 제기된 전자거래 소송에는 한국 법을 적용합니다.
부 칙(시행일) 본 약관은 2021년 5월 26일부터 적용합니다.
            </div>
        </div>
        <div class="footer">
         <div class="wrap">
             <div class="call">
                 <h3>CONTACT</h3>
                 <div class="call-con">
                     <p class="number">02-518-2603</p>
                     <p class="time"><span>상담시간</span>월~금 : 09:00AM~18:00PM</p>
                     <p>helphow@carrotglobal.com</p>
                 </div>
             </div>
             <div class="address">
                 <p>
                     서울특별시 강남구 강남대로 488 대남빌딩 4~9층 06120 │ ㈜캐럿글로벌 대표이사 : 노상충<br>
                     사업자등록번호: 211-88-50791 통신판매업신고번호 제 2017-서울강남-02979호 | <span @click="private_go()" style="cursor:pointer">개인정보처리방침</span> · <span @click="terms()" style="cursor:pointer">이용약관</span><br>
                     Copyright © <span class="bold">CARROT</span> Inc. All Rights reserved.<br>
                 </p>
                 <select name="" id="footer_select">
                     <option value="">Family Site</option>
                     <option value="http://www.carrotglobal.com/" target="_blank">CARROT HUB</option>
                     <option value="http:////www.carrotenglish.kr" target="_blank">전화영어:모바일 화상</option>
                     <option value="http://www.carrotglobal.com/global/" target="_blank">기업교육:글로벌 역량</option>
                     <option value="http://www.carrotglobal.net" target="_blank">CARROT Global</option>
                     <option value="http://www.how-writing.com/how/main.php" target="_blank">HOW</option>
                     <option value="//www.thespac.net" target="_blank">SPAC</option>
                     <option value="//www.imooc.co.kr" target="_blank">i:MOOC</option>
                 </select>
            </div>
         </div>
     </div>
        <div class="how-layer-bg" v-if="is_login">
            <div class="how-layer">
                <a href="#" class="float-right layer-close" @click="is_login = false">
                    <img src="../../assets/img/how/layer_close.png" alt="">
                </a>
                <div class="top">
                    <h1><img src="../../assets/img/how/logo_on.png"></h1>
                    <p>HOW Writing 역량강화 센터에 오신걸 환영합니다! </p>
                </div>
                <div class="login-box">
                    <div class="login-form">
                        <input placeholder="ID(E-Mail)를 입력해 주세요." class="input-login" v-model="info.email">
                    </div>
                    <p class="txt-alert" v-if="is_err_id">ID(E-Mail)를 입력해 주세요.</p>
                    <div class="login-form">
                        <input placeholder="비밀번호를 입력해 주세요." class="input-login" v-model="info.pw" type="password">
                    </div>
                    <p class="txt-alert" v-if="is_err_pw">비밀번호를 다시 확인해 주세요.</p>
                    <div class="login-setting">
                        <input type="checkbox" class="login-check" v-model="is_save" @change="saveIdpw()">
                        <label for="stln" class="lab-check">ID/PW 기억하기</label>
                    </div>
                    <button class="btn-login" @click="doSubmit()">로그인</button>
                    <!-- <div class="login-rel">
                        <span href="retyrb fa" style="cursor: pointer;" @click="showPwpop()" data-toggle="modal" data-target="#passwordModal">비밀번호를 잊으셨나요?</span>
                    </div> -->
                </div>
            </div>
        </div>
        <PwPopupModal :visible="pwVisible" @close="vue_close"></PwPopupModal>
    </div>
</template>
<script>
    import PwPopupModal from '../../components/pop_findPw.vue'
    export default {
        name: 'HowTerms',
        components: {
            PwPopupModal
        },
        data: () => ({
            pwVisible: false,
            info: {
                email: "",
                pw: ""
            },
            is_err_id: false,
            is_err_pw: false,
            is_save: false,
            is_login: false,
            is_mobile_menu: false,
            msg: ""
        }),
        mounted() {
            if (location.hostname == "stagest.carrotenglish.net") {
                this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
            } else if (location.hostname == "st.carrotenglish.net") {
                this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
            } else if (location.hostname == "student.carrotenglish.net") {
                this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
            } else if (location.hostname == "m.carrotenglish.net") {
                this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
            } else if (location.href.includes("how")) {
                if (location.href.includes("stage")) {
                    this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
                } else {
                    this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
                }
            } else {
                this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
            }
            this.is_save = false;
            if (localStorage.getItem("email") != null || localStorage.getItem("email") != "") {
                this.info.email = localStorage.getItem("email");
                this.info.pw = localStorage.getItem("pw");
                if (this.info.email == 'null') {
                    this.info.email = '';
                }
                if (this.info.pw == 'null') {
                    this.info.pw = '';
                }
                if (localStorage.getItem("is_save") == "1") {
                    this.is_save = true;
                } else {
                    this.is_save = false;
                }
            } else {
                this.info.email = "";
                this.info.pw = "";
                this.is_save = false;
                if (localStorage.getItem("is_save") == "1") {
                    this.is_save = true;
                } else {
                    this.is_save = false;
                }
            }
        },
        methods: {
            terms:function(){
                location.href="/how_terms";
            },
            private_go:function(){
                location.href="/how_privacy";
            },
            saveIdpw: function () {
                if (this.is_save == true) {
                    localStorage.setItem("email", this.info.email);
                    localStorage.setItem("pw", this.info.pw);
                    localStorage.setItem("is_save", "1");
                } else {
                    localStorage.setItem("email", "");
                    localStorage.setItem("pw", "");
                    localStorage.setItem("is_save", "0");
                }
            },
            showPwpop: function () {
                // this.is_login = false;
                // this.pwVisible = true;
                alert("비밀번호 재설정을 희망하시면, 02-518-2603으로 연락 부탁 드립니다.");
            },
            vue_close: function (state) {
                this.pwVisible = state;
                this.is_login = true;
            },
            doSubmit: function () {
                var me = this;
                console.log(me.info.email);
                if (me.info.email == "") {
                    this.is_err_id = true;
                    return false;
                } else {
                    this.is_err_id = false;
                }
                if (me.info.pw == "") {
                    this.is_err_pw = true;
                    return false;
                } else {
                    this.is_err_pw = false;
                }

                if (this.is_save == true) {
                    localStorage.setItem("email", this.info.email);
                    localStorage.setItem("pw", this.info.pw);
                    localStorage.setItem("is_save", "1");
                } else {
                    localStorage.setItem("email", "");
                    localStorage.setItem("pw", "");
                    localStorage.setItem("is_save", "0");
                }

                var email = this.info.email;
                var password = this.info.pw;
                this.$store.dispatch('LOGIN', {
                        email,
                        password
                    })
                    .then(() => this.redirect())
                    .catch(({
                        message
                    }) => this.msg = message)
                console.log(this.msg);
            }
        }
    }
</script>

<style lang="scss" scoped>
    // 폰트

    @font-face {
        font-family: 'Noto Sans KR', sans-serif;
        font-style: normal;
        font-weight: normal;
    }

    @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100;300;400;500;700;900&family=Roboto:wght@900&display=swap" rel="stylesheet');

    // 공통
    $point-color: #2a72ec;

    * {
        box-sizing: border-box;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
    }

    html {
        height: 100%;
    }

    body {
        font-family: 'Noto Sans KR', sans-serif;
        font-weight: 300;
        font-size: 18px;
        margin: 0;
        height: 100%;
        color: #474341;
        word-break: keep-all;
    }

    button {
        font-family: 'Noto Sans KR', sans-serif;
    }

    .body {
        min-height: 100%;
        position: relative;
        padding-bottom: 70px;
        overflow-x: hidden
    }

    .wrap {
        max-width: 1200px;
        width: 100%;
        margin: 0 auto;
        position: relative;
        padding-bottom: 10%;
    }

    .phone {
        display: none;
    }

    .phoneblock {
        display: none;
    }

    .phone-dp {
        display: inline-block;
    }

    input[type="text"],
    input[type="password"],
    select,
    textarea {
        height: 45px;
        padding: 10px;
        border: 1px solid #ccc;
        font-family: 'Noto Sans KR', sans-serif;
        font-size: 18px;

        &::placeholder {
            color: #a1a1a1;
            font-weight: 200;
        }
    }

    /*풋터*/
    .footer {
        position: absolute;
        bottom: 0;
        width: 100%;
        background: #373737;
        color: #cecece;
        padding: 30px 0;

        .address {
            font-size: 13px;
            font-weight: 100;
            float: left;
            width: 50%;

            p {
                margin-bottom: 20px;
                line-height: 25px;
            }

            select {
                border: none;
                padding: 5px 10px;
            }
        }

        .call {
            float: right;
            width: 45%;

            h3 {
                font-weight: bold;
                font-size: 18px;
                margin-bottom: 15px;
            }

            .call-con {
                width: 100%;
                border-top: 1px solid #dadada;
                padding-top: 15px;

                .number {
                    font-size: 25px;
                    font-weight: 500;
                }

                .time {
                    font-size: 13px;
                    letter-spacing: 1px !important;

                    span {
                        margin-right: 10px;
                    }
                }
            }
        }
    }

    /*상단네비*/
    .main-navi {
        position: absolute;
        width: 100%;
        z-index: 54;

        .navi-wrap {
            width: 100%;
            max-width: 1200px;
            margin: 0 auto;

            h1 {
                float: left;
            }

            .pc-navi {
                float: right;

                li {
                    display: inline-block;
                    vertical-align: middle;
                    font-size: 14px;
                    font-weight: bold;
                    position: relative;
                    margin-top: 10px;

                    &:last-child {
                        a {
                            padding-right: 0;
                        }
                    }

                    span {
                        display: block;
                        color: #fff;
                        padding: 15px 20px;
                    }

                    .pc-navi-dropmenu {
                        display: none;
                        position: absolute;
                        background: #fff;
                        z-index: 10;
                        left: -20px;
                        box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
                        -webkit-box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
                        -moz-box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);

                        li {
                            display: block;

                            &:hover {
                                background: #deebf1;
                            }

                            a {
                                display: block;
                                padding: 5px 40px;
                            }
                        }
                    }
                }
            }

            .m-navi {
                display: none;
            }

            .m-navi-btn {
                display: none;
            }
        }
    }

    /*메인*/
    .main-visual {
        background: #deebf1;
        background: url("../../assets/img/how/main_img.png") no-repeat left top;
        width: 100%;
        min-height: 400px;

        .how-title-wrap {
            padding-top: 200px;

            h2 {
                font-size: 40px;
                font-weight: bold;
                color: #fff;
            }

            h3 {
                color: #fff;
                padding-top: 15px;
                font-size: 20px;
            }
        }
    }

    .index-con {
        padding: 100px 0;

        h3 {
            font-size: 40px;
            font-weight: 700;
            margin-bottom: 30px;

            span {
                font-weight: 300;
            }
        }

        .how {
            position: relative;
            margin-bottom: 120px;

            .title {
                float: left;

                p {
                    line-height: 30px;
                }
            }

            .visual {
                position: absolute;
                right: 0;
                top: -15px;
                z-index: -1;
            }
        }

        .how-test {
            text-align: center;
            padding: 0 0 120px 0;

            ul {
                li {
                    display: inline-block;
                    vertical-align: top;
                    margin-right: 30px;

                    &:last-child {
                        margin-right: 0px;
                    }

                    .title {
                        font-weight: bold;
                        font-size: 21px;
                        margin-bottom: 15px;
                    }
                }
            }
        }

        .how-to {
            text-align: center;
            padding: 120px 0 120px 0;
            background: url(../../assets/img/how/how_to_img.png) no-repeat left top;
            color: #fff;

            .how-list {
                width: 1000px;
                margin: 50px auto 0 auto;

                .title {
                    background: #52CAFF;
                    padding: 15px 0;
                    font-size: 20px;
                    font-weight: bold;
                    border-radius: 25px 25px 0 0;
                }

                .con-box {
                    background: #fff;
                    padding: 50px;
                    border-radius: 0 0 25px 25px;

                    p {
                        font-size: 18px;
                        color: #373737;

                        &.how-to-img {
                            padding-top: 20px;
                        }
                    }
                }
            }
        }

        .how-process {
            width: 100%;
            padding: 120px 0 120px 0;
            text-align: center;

            h3 {
                margin-bottom: 50px;
            }

            ul {
                li {
                    display: inline-block;
                    vertical-align: top;
                    padding: 0 14px;

                    &:first-child {
                        padding-left: 0;
                    }

                    &:nth-child(2n) {
                        padding-top: 80px;
                    }

                    &:last-child {
                        padding-right: 0;
                    }

                    .title {
                        font-weight: bold;
                        font-size: 21px;
                        padding: 15px 0;
                    }

                    a {
                        font-size: 15px;
                        color: #005e9e;
                        font-weight: bold;
                        display: inline-block;
                        margin-top: 15px;

                        &::after {
                            display: block;
                            content: '';
                            border-bottom: 1px solid #005e9e;
                        }
                    }
                }
            }
        }

        .how-index {
            text-align: center;
            padding: 120px 0 0 0;
            background: url(../../assets/img/how/how_platform.png) no-repeat left top;

            ul {
                width: 100%;
                text-align: left;
                margin-top: 48px;

                li {
                    display: inline-block;

                    &.txt {
                        width: 400px;
                        text-align: left;
                        vertical-align: top;
                        margin-top: 100px;
                        font-size: 20px;

                        .sub {
                            padding-top: 15px;
                        }
                    }

                    &.phone-img {
                        width: 796px;
                        margin-left: -300px;
                    }
                }
            }
        }

        .how-class {
            text-align: center;
            padding: 120px 0 120px 0;
            background: url(../../assets/img/how/how_class_bg.png) no-repeat left top;
            color: #fff;
            background-size: cover;

            img {
                float: left;
                margin-top: 90px;
            }

            ul {
                // width: 1000px;
                width: 750px;
                margin: 50px auto 0 auto;
                margin-left: 54px;
                float: left;

                li {
                    border-radius: 15px;
                    background: #fff;
                    color: #373737;
                    padding: 20px;
                    margin-bottom: 30px;

                    p {
                        display: inline-block;
                        vertical-align: middle;

                        &.title {
                            width: 25%;
                        }

                        &.sub {
                            width: 74%;
                            // padding: 0 0 0 50px;
                            padding-left: 20px;
                            border-left: 1px dotted #999;
                            text-align: left;
                        }
                    }
                }
            }
        }
    }

    // 로그인 레이어 팝업
    .how-layer-bg {
        background-color: rgba(0, 0, 0, 0.7);
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 99999;
        overflow: auto;
        -ms-overflow-style: none;

        .how-layer {
            min-width: 500px;
            max-width: 600px;
            margin: 0 auto 50px auto;
            margin-top: 100px;
            background-color: #FFF;
            z-index: 9999;
            display: block;
            white-space: nowrap;
            position: relative;
            padding: 50px 0;

            .top {
                text-align: center;

                p {
                    font-size: 16px;
                }
            }

            .layer-close {
                display: inline-block;
                position: absolute;
                right: 0px;
                top: -50px;

                img {
                    width: 30px;
                }
            }

            .login-box {
                width: 80%;
                margin: 40px auto 00px auto;
                display: block;
                padding-bottom: 20px;

                .login-form {
                    position: relative;
                    margin-top: 10px;
                    border: 1px solid #dadada;
                    font-size: 15px;

                    input {
                        &.input-login {
                            display: block;
                            width: 100%;
                            height: 40px;
                            padding: 0 15px;
                            border: 0;
                            font-weight: bold;
                            font-size: 15px;
                            line-height: 25px;
                            color: #1e1e1e;
                            vertical-align: top;
                            background-color: transparent;
                            outline: 0;
                        }
                    }

                    .txt-alert {
                        color: #ff6969;
                        font-size: 12px;
                        margin: 5px 0 10px 0;
                        display: none;
                    }
                }

                .login-setting {
                    margin-top: 10px;

                    .lab-check {
                        font-size: 16px;
                    }
                }

                .btn-login {
                    width: 100%;
                    padding: 13px 0;
                    text-align: center;
                    background: #404040;
                    cursor: pointer;
                    font-size: 16px;
                    font-weight: bold;
                    color: #ffffff;
                    margin: 30px 0 0 0;
                    border: none;
                }

                .login-rel {
                    text-align: center;
                    font-size: 16px;
                    margin-top: 30px;
                }
            }
        }

    }


    // 반응형 시작

    /*반응형 - 아이패드프로 (세로) 기준*/
    @media only screen and (max-width: 1024px) {

        /*공통*/
        .body {
            min-height: 100%;
            position: relative;
            padding-bottom: 320px;
        }

        .wrap {
            width: 95%;
        }

        /*네비 (메인)*/
        .main-navi {
            .navi-wrap {
                width: 95%;
                padding: 10px 0;

                h1 {
                    margin-top: 0;
                    width: 150px;

                    img {
                        width: 100%;
                    }
                }

                .pc-navi {
                    display: none;
                }

                .m-navi-btn {
                    display: block;
                    float: right;
                    font-size: 16px;
                    color: #fff;
                    font-weight: bold;
                    margin-top: 10px;
                }

                .m-navi {
                    // position: absolute;
                    position: fixed;
                    top: 0;
                    right: 0;
                    z-index: 999;
                    height: 100%;
                    min-height: 100%;
                    background: #fff;
                    width: 310px;
                    display: block;

                    .m-navi-top {
                        display: block;
                        padding: 20px;

                        a {
                            // color: #fff;
                            float: right;
                        }
                    }

                    .m-navi-con {
                        .m-navi-li {
                            border-bottom: 1px solid #eeeeee;

                            a {
                                padding: 10px 20px;
                                display: block;
                            }
                        }
                    }
                }
            }
        }

        .main-visual {
            .wrap {
                padding-top: 200px;

                .how-title-wrap {
                    margin-top: 0;
                    width: 90%;
                    margin: 0 auto;
                    text-align: center;
                }
            }
        }

        .index-con {
            .how-test {
                padding: 0 0 40px 0;

                ul {
                    li {
                        margin-bottom: 30px;
                        width: 100%;

                        p {
                            &.title {
                                font-size: 18px;
                            }

                            &.sub {
                                font-size: 16px;
                            }
                        }

                        img {
                            width: 100%;
                        }
                    }
                }
            }

            .how-to {
                padding: 50px 0;

                .how-list {
                    width: 100%;
                    margin: 40px auto 0 auto;

                    .title {
                        padding: 15px;
                        font-size: 18px;
                    }

                    .con-box {
                        padding: 20px;

                        p {
                            font-size: 16px;

                            &.how-to-img {
                                img {
                                    width: 100%;
                                }
                            }
                        }
                    }
                }
            }

            .how-process {
                padding: 50px 0;

                ul {
                    li {
                        width: 40%;
                        margin-right: 6%;
                        padding: 0;

                        img {
                            width: 100%;
                        }

                        &:nth-child(2n) {
                            display: none;
                        }

                        &:nth-child(3n) {
                            margin-right: 0;
                        }

                        .title {
                            font-size: 16px;
                        }
                    }
                }
            }

            .how-index {
                padding: 50px 0 0 0;

                ul {
                    width: 100%;
                    text-align: left;
                    margin-top: 30px;

                    li {
                        &.txt {
                            width: 100%;
                            margin-top: 0;
                            text-align: center;
                            margin-bottom: 30px;
                            font-size: 20px;

                            p {
                                &.title {
                                    width: 100%;
                                }

                                &.sub {
                                    padding-top: 20px;
                                    font-size: 16px;
                                }
                            }
                        }

                        &.phone-img {
                            width: 100%;
                            margin-left: 0;

                            img {
                                width: 100%;
                            }
                        }
                    }
                }
            }

            .how-class {
                padding: 50px 0;
                background-size: cover;

                .wrap {
                    img {
                        width: 100%;
                        margin-top: 30px;
                    }
                }

                ul {
                    width: 100%;
                    margin: 30px auto 0 auto;

                    li {
                        padding: 20px;
                        margin-bottom: 30px;

                        p {
                            &.title {
                                width: 100%;
                                padding-bottom: 15px;
                                border-bottom: 1px dotted #999;
                            }

                            &.sub {
                                width: 100%;
                                padding: 0;
                                border-left: 0;
                                font-size: 16px;
                                text-align: center;
                                padding-top: 15px;
                            }
                        }
                    }
                }
            }
        }

        /*레이어 팝업*/
        .how-layer-bg {
            .how-layer {
                min-width: 90%;
                max-width: 90%;
                margin: 50px auto;

                .layer-close {
                    top: -40px;
                }

                .top {
                    text-align: center;
                    width: 90%;
                    margin: 0 auto;

                    p {
                        white-space: normal;
                        font-size: 14px;
                    }
                }

                .login-box {
                    width: 90%;
                    margin: 30px auto 00px auto;

                    .login-rel {
                        font-size: 14px;
                    }

                    .login-setting {
                        .lab-check {
                            font-size: 14px;
                        }
                    }
                }
            }
        }
    }

    /*반응형 - 아이패드 기준*/
    @media only screen and (max-width: 768px) {

        /*공통*/
        .body {
            min-height: 100%;
            position: relative;
            padding-bottom: 320px;
        }

        .wrap {
            width: 95%;
        }

        /*메인*/
        .main-visual {
            min-height: 600px;
            background-position-x: center;
            background-size: cover;

            .wrap {
                width: 100%;
                padding-top: 0;
            }

            .how-title-wrap {
                h2 {
                    font-size: 35px;
                }
            }
        }

        .index-con {
            padding: 60px 0 0px 0;

            h3 {
                font-size: 24px;
            }

            .how-test {
                p {
                    font-size: 16px;
                }
            }
        }

        /*풋터*/
        .footer {
            .address {
                float: none;
                width: 100%;
            }

            .call {
                float: none;
                width: 100%;
                margin-bottom: 20px;
            }
        }
    }

    /*반응형 - 아이폰플러스 기준*/
    @media only screen and (max-width: 414px) {

        /*공통*/
        .m-br {
            display: block;
        }

        .phone-disnone {
            display: none !important;
        }

        .body {
            padding-bottom: 382px;
        }
    }
</style>